import styled from "styled-components";
import FONTS from "../../constants/fonts";

export const Wrapper = styled.div`
  display: flex;
  pointer-events: all;
  justify-content: space-between;
  align-items: center;
  width: 36rem;
  margin-bottom: 2rem;
  margin-left: 2rem;
  background: #00000090;
  border-radius: 4px;
  padding: 1.6rem;
`;

export const Message = styled.div`
  font-size: 1.6rem;
  color: #ffffff;
  font-family: ${FONTS.UbuntuLight};
  flex-grow: 1;
  text-align: center;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 0px 18px rgba(0, 150, 198, 0.95);
`;

export const CloseBtn = styled.div`
  font-size: 2rem;
  padding: 0.4rem;
  color: #ffffff;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 0px 18px rgba(0, 150, 198, 0.95);
  font-family: ${FONTS.UbuntuLight};
  cursor: pointer;
  margin-left: 1.6rem;
`;
